import React from 'react';
import { formatCurrency } from '../utils/formatter';

function WaterfallReport({ forecastData }) {
  if (!forecastData || !forecastData.base) {
    return null;
  }

  // Calculate conversion metrics from base scenario
  const baseData = forecastData.base;

  // Get totals across all months
  const totalSQLs = baseData.reduce((sum, row) => sum + row.sqls, 0);
  const totalSQOs = baseData.reduce((sum, row) => sum + row.sqos, 0);
  const totalClosedWon = baseData.reduce((sum, row) => sum + row.closedWon, 0);
  const totalRevenue = baseData.reduce((sum, row) => sum + row.revenue, 0);

  // Calculate conversion rates
  const sqlToSqoRate = totalSQLs > 0 ? (totalSQOs / totalSQLs) * 100 : 0;
  const sqoToCwRate = totalSQOs > 0 ? (totalClosedWon / totalSQOs) * 100 : 0;
  const sqlToCwRate = totalSQLs > 0 ? (totalClosedWon / totalSQLs) * 100 : 0;

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-2">Revenue Waterfall Report</h2>
      <p className="text-gray-600 mb-6">FY26 Sales funnel analysis: SQL → SQO → Closed Won</p>

      {/* Executive Summary Cards */}
      <div className="grid grid-cols-4 gap-4 mb-8">
        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
          <div className="text-sm font-semibold text-gray-600 mb-2">Total SQLs</div>
          <div className="text-3xl font-bold text-blue-600">{totalSQLs.toLocaleString()}</div>
          <div className="text-xs text-gray-500 mt-2">Sales Qualified Leads</div>
        </div>

        <div className="bg-indigo-50 rounded-lg p-4 border border-indigo-200">
          <div className="text-sm font-semibold text-gray-600 mb-2">Total SQOs</div>
          <div className="text-3xl font-bold text-indigo-600">{totalSQOs.toLocaleString()}</div>
          <div className="text-xs text-gray-500 mt-2">SQL → SQO: {sqlToSqoRate.toFixed(1)}%</div>
        </div>

        <div className="bg-green-50 rounded-lg p-4 border border-green-200">
          <div className="text-sm font-semibold text-gray-600 mb-2">Closed Won</div>
          <div className="text-3xl font-bold text-green-600">{totalClosedWon.toLocaleString()}</div>
          <div className="text-xs text-gray-500 mt-2">SQO → CW: {sqoToCwRate.toFixed(1)}%</div>
        </div>

        <div className="bg-purple-50 rounded-lg p-4 border border-purple-200">
          <div className="text-sm font-semibold text-gray-600 mb-2">Total ARR</div>
          <div className="text-3xl font-bold text-purple-600">{formatCurrency(totalRevenue)}</div>
          <div className="text-xs text-gray-500 mt-2">Overall Win Rate: {sqlToCwRate.toFixed(1)}%</div>
        </div>
      </div>

      {/* Key Insights */}
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
        <h4 className="font-semibold text-amber-900 mb-2">Key Insights</h4>
        <ul className="text-sm text-amber-800 space-y-1">
          <li>• Overall funnel conversion (SQL → Closed Won): <span className="font-semibold">{sqlToCwRate.toFixed(1)}%</span></li>
          <li>• SQL to SQO conversion: <span className="font-semibold">{sqlToSqoRate.toFixed(1)}%</span></li>
          <li>• SQO to Closed Won conversion: <span className="font-semibold">{sqoToCwRate.toFixed(1)}%</span></li>
          <li>• Average deal value: <span className="font-semibold">{formatCurrency(totalRevenue / totalClosedWon)}</span></li>
        </ul>
      </div>
    </div>
  );
}

export default WaterfallReport;
